import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Loop } from "swiper/modules";

const CardSwiperSlider = ({imagesData}) => {

    const swiperRef = useRef(null);

  const handleMouseEnter = () => {
    if (swiperRef.current) {
      swiperRef.current.autoplay.stop();
    }
  };

  const handleMouseLeave = () => {
    if (swiperRef.current) {
      swiperRef.current.autoplay.start();
    }
  };
  

  return (
    <section className="cardswiperslider-container mt-5">
      <div className="container-fluid">


        <Swiper
                  onSwiper={(swiper) => (swiperRef.current = swiper)}

          spaceBetween={20}
        breakpoints={{
            0: { 
              slidesPerView: 2,
            },
            1024: { 
              slidesPerView: 2.2,
            },
          }}
          loop={true}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          modules={[Autoplay]}
          className="cardswiperslider"
          style={{zIndex:'0'}}
        >
          {imagesData.map((src, index) => (
            <SwiperSlide key={index}>
              <div className="cardswiperslider-card "  onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}>
                <img src={src} alt="card" className="img-fluid " />
               
              </div>
            </SwiperSlide>
          ))}



        </Swiper>

        
      </div>
    </section>
  );
};

export default CardSwiperSlider;


